import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["heading", "subheading", "actionBar", "cards"],
  _excluded2 = ["id", "image"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { memo, useMemo } from 'react';
import { SIZE as HEADING_SIZE } from "../typography/headline/next";
import { SIZE as TEXT_SIZE } from "../typography/text/next";
import ActionBar from "../action-bar";
import chunk from 'lodash.chunk';
import { HeadingsContainer, Heading, Subheading, Section, ActionBarContainer, CardsContainer, CardContainer } from "./content-grid-module.styles";
import Card from "./card";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ContentGridModule = function ContentGridModule(_ref) {
  var heading = _ref.heading,
    subheading = _ref.subheading,
    actionBar = _ref.actionBar,
    cards = _ref.cards,
    rest = _objectWithoutProperties(_ref, _excluded);
  var cardItems = useMemo(function () {
    var chunks = chunk(cards, 3);
    return chunks.map(function (cards) {
      return cards.map(function (_ref2, index) {
        var id = _ref2.id,
          image = _ref2.image,
          card = _objectWithoutProperties(_ref2, _excluded2);
        return /*#__PURE__*/_jsx(CardContainer, {
          index: index,
          cardsLength: cards.length,
          children: /*#__PURE__*/_jsx(Card, _objectSpread(_objectSpread({}, card), {}, {
            image: image
          }))
        }, id);
      });
    });
  }, [cards]);
  return /*#__PURE__*/_jsxs(Section, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/_jsxs(HeadingsContainer, {
      children: [/*#__PURE__*/_jsx(Heading, {
        element: "h2",
        size: HEADING_SIZE.TWO,
        mediumViewportsSize: HEADING_SIZE.THREE,
        largeViewportsSize: HEADING_SIZE.FOUR,
        children: heading
      }), subheading && /*#__PURE__*/_jsx(Subheading, {
        size: TEXT_SIZE.S,
        largeViewportsSize: TEXT_SIZE.M,
        children: subheading
      })]
    }), /*#__PURE__*/_jsx(CardsContainer, {
      children: cardItems
    }), actionBar && /*#__PURE__*/_jsx(ActionBarContainer, {
      children: /*#__PURE__*/_jsx(ActionBar, _objectSpread({}, actionBar))
    })]
  }));
};
export default /*#__PURE__*/memo(ContentGridModule);